import React from 'react';
import { Link } from 'react-router-dom';
import './Producto.css';

const Producto = ({ id, name, category, image }) => {
  return (
    <div className="producto">
      <img src={image} alt={name} className="producto-img" />
      <div className="producto-info">
        <p className="producto-category">{category}</p>
        <h3 className="producto-name mb-2">{name}</h3>
        <Link to={`/producto/${id}`}>
          <button className="producto-btn mb-3">+ Info</button>
        </Link>
      </div>
    </div>
  );
};

export default Producto;
